import { useEffect } from 'react'

/** Fecha painel/modal com Escape. */
export function useTeclaEscape(ativo: boolean, aoPressionar: () => void): void {
  useEffect(() => {
    if (!ativo) return

    const tratar = (evento: KeyboardEvent) => {
      if (evento.key === 'Escape') aoPressionar()
    }
    document.addEventListener('keydown', tratar)
    return () => document.removeEventListener('keydown', tratar)
  }, [ativo, aoPressionar])
}
